const hostName = process.env.REACT_APP_BASE_URL; // dev
//const hostName = "test-ticketing-be.machint.com";
// const hostName = "http://10.15.14.50:8000";
export const baseURL = `https://${hostName}`;
export const webSocketUrl =
  (window.location.protocol === "https:" ? "wss://" : "wss://") +
  `${hostName}/masterdata/ws?token=`;
